<template>
    <div id="settings-articles-page">
        <div class="top-buttons">
            <ui5-button @click="$router.push('/settings')">{{ trans('pages.settings_articles.back') }}</ui5-button>
        </div>
        <div class="error" v-if="createError">{{ createError }}</div>
        <div v-if="prefixes" class="prefixes">
            <i
                class="fa fa-plus"
                @click="createPrefix({ parent: null, level: 1 })" />
            <div class="level">
                <prefix-item
                    v-for="prefix in getLevel(null, 1)"
                    :key="prefix.ID"
                    :prefix="prefix"
                    :on-drop="onDrop"
                    :add-drag-class="addDragClass"
                    :remove-drag-class="removeDragClass" />
                <div class="prefix-item-container">
                    <div
                        class="prefix-item"
                        @drop="onDrop"
                        data-level="1"
                        @dragover="allowDrop"
                        @dragenter="addDragClass"
                        @dragleave="removeDragClass">
                        <span class="free-title">{{ trans('pages.settings_articles.free') }}</span>
                        <span v-if="isDebug">- 1</span>
                        <i
                            class="fa fa-plus"
                            @click="createPrefix({ parent: null, level: 2 })" />
                    </div>
                    <div class="level">
                        <prefix-item
                            v-for="prefix in getFreePrefixes(2)"
                            :on-drop="onDrop"
                            :key="prefix.ID"
                            :add-drag-class="addDragClass"
                            :remove-drag-class="removeDragClass"
                            :prefix="prefix" />

                        <div class="prefix-item-container">
                            <div
                                class="prefix-item"
                                @drop="onDrop"
                                data-level="2"
                                @dragover="allowDrop"
                                @dragenter="addDragClass"
                                @dragleave="removeDragClass">
                                <span class="free-title">{{ trans('pages.settings_articles.free') }}</span>
                                <span v-if="isDebug">- 2</span>
                                <i
                                    class="fa fa-plus"
                                    @click="
                                        createPrefix({ parent: null, level: 3 })
                                    " />
                            </div>
                            <div class="level">
                                <prefix-item
                                    :prefix="prefix"
                                    :on-drop="onDrop"
                                    :add-drag-class="addDragClass"
                                    :remove-drag-class="removeDragClass"
                                    v-for="prefix in getFreePrefixes(3)"
                                    :key="prefix.ID" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PrefixItem from '../components/articles/prefix-item';
import { mapActions, mapGetters } from 'vuex';
import IsDebugMixin from '../mixins/is-debug';
import localization from '../mixins/localization';

export default {
    components: { PrefixItem },
    mixins: [IsDebugMixin, localization],
    methods: {
        ...mapActions({
            loadPrefixes: 'articles/loadPrefixes',
            createPrefix: 'articles/createPrefix',
            updatePrefixParent: 'articles/updatePrefixParent',
        }),
        allowDrop(e) {
            e.preventDefault();
        },
        onDrop(e) {
            const sourceId = e.dataTransfer.getData('text');
            const source = this.getPrefixById(sourceId);

            const targetId = e.target.getAttribute('data-id');
            const target = targetId
                ? this.getPrefixById(targetId)
                : { level: e.target.getAttribute('data-level') };

            //only allow updating parent, not level for now
            this.updatePrefixParent({ prefix: source, parentId: target.ID });

            e.target.classList.remove('drag-target');
            e.target.classList.remove('dragged-over');
        },
        addDragClass(e) {
            const target = e.target;
            const source = this.$el.querySelector('.prefix-item.dragged');
            const sourceParent = source.getAttribute('data-parent');

            const sourceLevel = source.getAttribute('data-level');
            const targetLevel = target.getAttribute('data-level');
            const targetId = target.getAttribute('data-id');

            if (
                !target.isEqualNode(source) &&
                sourceLevel - 1 == targetLevel &&
                sourceParent != targetId
            ) {
                if (target.classList.contains('prefix-item')) {
                    target.classList.add('dragged-over');
                    const level = target.getAttribute('data-level');
                    if (level < 3) {
                        target.classList.add('drag-target');
                    }
                }
            }
        },
        removeDragClass(e) {
            e.target.classList.remove('drag-target');
            e.target.classList.remove('dragged-over');
        },
    },
    computed: {
        ...mapGetters({
            getLevel: 'articles/getLevel',
            getFreePrefixes: 'articles/getFreePrefixes',
            prefixes: 'articles/getPrefixes',
            createError: 'articles/getCreateError',
            getPrefixById: 'articles/getPrefixById',
        }),
    },
    mounted() {
        this.loadPrefixes();
    },
};
</script>
